import { render, staticRenderFns } from "./InternalMovingMaterials.vue?vue&type=template&id=770bbb32&scoped=true"
import script from "./InternalMovingMaterials.vue?vue&type=script&lang=js"
export * from "./InternalMovingMaterials.vue?vue&type=script&lang=js"
import style0 from "./InternalMovingMaterials.vue?vue&type=style&index=0&id=770bbb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770bbb32",
  null
  
)

export default component.exports